<template>
  <a :href="'/' + lang + '/activities/' + activity.code + '/' + activity.slug" target="_blank">
    <div class="c-activity">
      <div class="c-activity-thumb">
        <v-img
          :src="`${cdnUrl}/activities/thumbnails/` + activity.images[0].image"
          onerror="https://devigro.com/images/logo@2x.png"
          :aspect-ratio="3 / 2"
        >
          <template v-slot:placeholder>
            <v-sheet>
              <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-sheet>
          </template>
        </v-img>
        <div class="c-activity-year">{{ trans('AGES') }} {{ activity.agefromto }}</div>
      </div>
      <div class="c-activity-info">
        <div class="c-activity-top">
          <div class="c-activity-rating">
            <div v-if="activity.reviews.length > 0">
              <i class="material-icons-round text-secondary">star</i>
              <span class="text-dark">{{ activity.avgrating }} ({{ activity.reviews.length }})</span>
            </div>
            <div v-else>
              <span class="text-dark">{{ trans('No reviews yet') }}</span>
            </div>
          </div>

          <div class="c-activity-title text-dark font-weight-bold">
            {{ activity.name }}
          </div>
          <div v-if="activity.avl_terms.length > 0">
            <div class="text-capitalize text-dark text-truncate" style="font-size: 14px;" :title="activity.avl_terms | formatActivityTime">
              {{ activityTime }}
            </div>
          </div>
          <div v-if="activity.is_online" class="c-activity-title text-dark" style="font-size: 14px;">
            Online
          </div>
          <div v-else class="c-activity-title text-dark" style="font-size: 14px;">
            {{ trans(activity.location.get_city.name) }} .
            {{ trans(activity.location.get_district.name) }}
          </div>
        </div>
        <div class="c-activity-bottom">
          <div class="c-activity-price">
            {{ trans('From') }}
            <span class="text-primary">{{ activityPrice | formatActivityPrice }}</span>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ['activity', 'lang'],
  data() {
    return {
      maxLen: 38,
      formatActivityTime: this.$options.filters.formatActivityTime,
    }
  },
  computed: {
    activityTime() {
      const formattedActivityTime = this.formatActivityTime(this.activity.avl_terms)
      return formattedActivityTime;
    },
    activityPrice() {
      const sessions = this.activity.avl_terms
      const dropInSessions = sessions.filter(item => item.type)
      const fullSessions = sessions.filter(item => !item.type)

      if (dropInSessions.length > 0) {
        dropInSessions.sort((a, b) => a.child_price - b.child_price)
        return dropInSessions[0]
      }

      fullSessions.sort((a, b) => a.child_price - b.child_price)

      return fullSessions[0];
    },
    tenantId() {
			return window.tenant;
		},
    cdnUrl() {
			return window.cdn_url;
		}
  },
  created() {
    if (window.screen.width <= 420 && window.screen.width >= 349) {
      this.maxLen = 60;
    } else if (window.screen.width <= 348) {
      this.maxLen = 40;
    }
    
  }
}
</script>
